import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=1eb64000&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"
import style0 from "./Works.vue?vue&type=style&index=0&id=1eb64000&prod&scoped=true&lang=css"
import style1 from "./Works.vue?vue&type=style&index=1&id=1eb64000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb64000",
  null
  
)

export default component.exports